export const LOGO_URL =
  'https://static.readdy.ai/image/6e6f586929bab4b45ad1bd9812f7687b/c0b063b12084b2579388308d42ec49b7.png';

export function getSiteUrl(): string {
  const raw = (import.meta.env.VITE_SITE_URL as string) || '';
  return raw.replace(/\/+$/, '');
}

export interface SeoData {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  ogImage?: string;
  noindex?: boolean;
}

export const seoDataByPath: Record<string, SeoData> = {
  '/': {
    title: 'Somukoi | Citizen Journalism Platform Northeast India',
    description:
      'Somukoi empowers Northeast India communities through citizen journalism. Share stories, culture, innovations, and real voices that matter.',
    keywords: 'Somukoi, citizen journalism, Northeast India, community stories, culture',
    path: '/',
    ogType: 'website',
    ogImage: LOGO_URL,
  },
  '/blogs': {
    title: 'Community Stories & Blogs | Somukoi',
    description:
      'Discover inspiring community stories, cultural moments, youth innovations, and citizen journalism from Northeast India on the Somukoi blog.',
    keywords: 'community stories, blogs, Northeast India, culture, citizen journalism',
    path: '/blogs',
    ogType: 'website',
    ogImage: LOGO_URL,
  },
  '/citizen-submission': {
    title: 'Submit Your Story | Somukoi',
    description: '',
    keywords: '',
    path: '/citizen-submission',
    noindex: true,
  },
};